export default class MembersTreeViewNodeHelper {
    static GetLoadAdditionalMembersNode = () => {
        return {
            "id": "expandToLoadMore",
            "name": "Expand To Load Additional Members",
            "isExpanded": false,
            "isChecked": false,
            "isExpandable": true,
            "isCheckable": false,
            "lastChanged": null,
            "children": null,
            "value": {
                "caption": "",
                "dimensionAlias": "",
                "dimensionSystemName": "",
                "valueAlias": "",
                "valueSystemName": "",
                "member": false,
                "segment": false,
                "multiSegment": false,
                "segmentNames": false,
                "segmentMembers": false,
                "parentName": "",
                "parentType": 0
            }
        };
    };
    static GetIndividualMemberTreeViewNode = (dimensionMember, dimension, iterator, selected) => {
        return {
            "id": iterator,
            "name": `Member ${dimensionMember.alias}`,
            "isExpanded": false,
            "isChecked": selected,
            "isExpandable": false,
            "isCheckable": true,
            "lastChanged": null,
            "children": null,
            "value": {
                "caption": `Member ${dimensionMember.alias}`,
                "dimensionAlias": dimension.alias,
                "dimensionSystemName": dimension.systemName,
                "valueAlias": dimensionMember.alias,
                "valueSystemName": dimensionMember.systemName,
                "member": true,
                "segment": false,
                "multiSegment": false,
                "segmentNames": false,
                "segmentMembers": false,
                "parentName": dimension.alias,
                "parentType": 0
            },
        };
    };
    static GetSegmentMembersNode = (segment, dimension, iterator, selected=false) => {
        return {
            "id": iterator,
            "name": `Segment ${segment.alias} Members`,
            "isExpanded": false,
            "isChecked": selected,
            "isExpandable": false,
            "isCheckable": true,
            "lastChanged": null,
            "children": [],
            "value": {
                "caption": `Segment ${segment.alias} Members`,
                "segmentAlias": segment.alias,
                "segmentSystemName": segment.systemName,
                "dimensionAlias": dimension.alias,
                "dimensionSystemName": dimension.systemName,
                "valueAlias": "All",
                "valueSystemName": "",
                "member": false,
                "segment": true,
                "multiSegment": false,
                "segmentNames": true,
                "segmentMembers": false
            }
        };
    };
    static GetSegmentRollupNode = (segment, dimension, iterator, selected=false) => {
        return {
            "id": iterator,
            "name": `Segment ${segment.alias} Rollup`,
            "isExpanded": false,
            "isChecked": selected,
            "isExpandable": false,
            "isCheckable": true,
            "lastChanged": null,
            "children": [],
            "value": {
                "caption": `Segment ${segment.alias} Rollup`,
                "segmentAlias": segment.alias,
                "segmentSystemName": segment.systemName,
                "dimensionAlias": dimension.alias,
                "dimensionSystemName": dimension.systemName,
                "valueAlias": null,
                "valueSystemName": null,
                "member": false,
                "segment": true,
                "multiSegment": false,
                "segmentNames": true,
                "segmentMembers": false
            }
        };
    };
    static GetSegmentMembersSuperNode = (segment, dimension, iterator, node, nodeCaption = 'Members', memberAlias = '', memberSystemName = '') => {
        let rtnVal = {
            "id": iterator,
            "name": nodeCaption,
            "isExpanded": false,
            "isChecked": false,
            "isExpandable": true,
            "isCheckable": false,
            "lastChanged": null,
            "children": null,
            "value": {
                "caption": nodeCaption,
                "dimensionAlias": dimension["alias"],
                "dimensionSystemName": dimension["systemName"],
                "valueAlias": segment["alias"],
                "valueSystemName": segment["systemName"],
                "member": false,
                "segment": true,
                "multiSegment": false,
                "segmentNames": true,
                "segmentMembers": false,
                "parentName": dimension["alias"],
                "parentType": 0
            }
        };

        // If this is true, we have included this node within a multi segment selector
        if (node["value"]["nodeSegments"] !== undefined
            && node["value"]["segmentLevel"] !== undefined
            && node["value"]["nodeSegmentsMembers"] !== undefined
            && node["value"]["nodeSegmentsMemberSystemNames"] !== undefined) {

            rtnVal["value"]["nodeSegments"] = node["value"]["nodeSegments"];
            rtnVal["value"]["segmentLevel"] = (node["value"]["segmentLevel"] + 1);

            // Segment System Names
            rtnVal["value"]["nodeSegmentSystemNames"] = [];
            node.value.nodeSegmentSystemNames.forEach(sm => {
                rtnVal.value.nodeSegmentSystemNames.push(sm);
            });
            rtnVal.value.nodeSegmentSystemNames.push(segment["systemName"]);

            // Segment Members
            rtnVal["value"]["nodeSegmentsMembers"] = [];
            node.value.nodeSegmentsMembers.forEach(sm => {
                rtnVal.value.nodeSegmentsMembers.push(sm);
            });
            if (memberAlias !== '') {
                rtnVal.value.nodeSegmentsMembers.push(memberAlias);
            }

            // Segment Member System Names
            rtnVal["value"]["nodeSegmentsMemberSystemNames"] = [];
            node.value.nodeSegmentsMemberSystemNames.forEach(sm => {
                rtnVal.value.nodeSegmentsMemberSystemNames.push(sm);
            });
            if (memberSystemName !== '') {
                rtnVal.value.nodeSegmentsMemberSystemNames.push(memberSystemName);
            }
        }

        return rtnVal;
    };
    static GetSegmentValueMembersNode = (segment, dimensionMember, dimension, iterator, selected) => {
        return {
            "id": iterator,
            "name": `Segment ${segment.alias} Value ${dimensionMember.alias} Members`,
            "isExpanded": false,
            "isChecked": selected,
            "isExpandable": false,
            "isCheckable": true,
            "lastChanged": null,
            "children": [],
            "value": {
                "caption": `Segment ${segment.alias} Value ${dimensionMember.alias} Members`,
                "parentName": `[${segment.alias}] == [${dimensionMember.alias}]`,
                "parentType": 1,
                "dimensionAlias": dimension.alias,
                "dimensionSystemName": dimension.systemName,
                "valueAlias": "All",
                "valueSystemName": segment.systemName,
                "member": true,
                "segment": false,
                "multiSegment": false,
                "segmentNames": false,
                "segmentMembers": false
            }
        };
    };
    static GetSegmentValueRollupNode = (segment, dimensionMember, dimension, iterator, selected) => {
        return {
            "id": iterator,
            "name": `Segment ${segment.alias} Value ${dimensionMember.alias} Rollup`,
            "isExpanded": false,
            "isChecked": selected,
            "isExpandable": false,
            "isCheckable": true,
            "lastChanged": null,
            "children": [],
            "value": {
                "caption": `Segment ${segment.alias} Value ${dimensionMember.alias} Rollup`,
                "segmentAlias": segment.alias,
                "segmentSystemName": segment.systemName,
                "dimensionAlias": dimension.alias,
                "dimensionSystemName": dimension.systemName,
                "valueAlias": dimensionMember.alias,
                "valueSystemName": dimensionMember.systemName,
                "member": false,
                "segment": true,
                "multiSegment": false,
                "segmentNames": false,
                "segmentMembers": false
            }
        };
    };
    static GetSegmentValueMembersSuperNode = (segment, dimensionMember, dimension, iterator, node) => {
        let rtnVal = {
            "id": iterator,
            "name": "Members",
            "isExpanded": false,
            "isChecked": false,
            "isExpandable": true,
            "isCheckable": false,
            "lastChanged": null,
            "children": null,
            "value": {
                "caption": "Members",
                "dimensionAlias": dimension.alias,
                "dimensionSystemName": dimension.systemName,
                "valueAlias": dimensionMember.alias,
                "valueSystemName": dimensionMember.systemName,
                "member": false,
                "segment": true,
                "multiSegment": false,
                "segmentNames": false,
                "segmentMembers": true,
                "parentName": segment.alias,
                "parentType": 0
            }
        };

        // If this is true, we have included this node within a multi segment selector
        if (node["value"]["nodeSegments"] !== undefined
            && node["value"]["segmentLevel"] !== undefined
            && node["value"]["nodeSegmentsMembers"] !== undefined
            && node["value"]["nodeSegmentsMemberSystemNames"] !== undefined) {

            rtnVal["value"]["nodeSegments"] = node["value"]["nodeSegments"];
            rtnVal["value"]["segmentLevel"] = (node["value"]["segmentLevel"] + 1);

            // nodeSegmentSystemNames
            rtnVal["value"]["nodeSegmentSystemNames"] = [];
            node.value.nodeSegmentSystemNames.forEach(sm => {
                rtnVal.value.nodeSegmentSystemNames.push(sm);
            });

            // nodeSegmentsMembers
            rtnVal["value"]["nodeSegmentsMembers"] = [];
            node.value.nodeSegmentsMembers.forEach(sm => {
                rtnVal.value.nodeSegmentsMembers.push(sm);
            });

            // nodeSegmentsMemberSystemNames
            rtnVal["value"]["nodeSegmentsMemberSystemNames"] = [];
            node.value.nodeSegmentsMemberSystemNames.forEach(sm => {
                rtnVal.value.nodeSegmentsMemberSystemNames.push(sm);
            });
        }

        return rtnVal;
    };
    static GetHighestLevelMultiSegmentNodes = (selections, level) => {
        let rtnVal = [];

        selections.forEach(selection => {
            if (selection.segmentCombination !== undefined) {
                let segments = selection.segmentCombination.split("|");

                rtnVal.push({
                    "id": selection.segmentCombination,
                    "name": selection.segmentCombination.replace(/\|/g, " "),
                    "isExpanded": false,
                    "isChecked": false,
                    "isExpandable": true,
                    "isCheckable": false,
                    "lastChanged": null,
                    "children": null,
                    "value": {
                        "nodeSegments": segments,
                        "nodeSegmentSystemNames": [],
                        "nodeSegmentsMembers": [],
                        "nodeSegmentsMemberSystemNames": [],
                        "segmentLevel": level
                    }
                });
            }
        });

        return rtnVal;
    };
    static GetAddedLevelMultiSegmentNodes = (added) => {
        let rtnVal = [];

        added.forEach(selection => {
            let segments = selection.split("|");

            rtnVal.push({
                "id": selection,
                "name": selection.replace(/\|/g, " "),
                "isExpanded": false,
                "isChecked": false,
                "isExpandable": true,
                "isCheckable": false,
                "lastChanged": null,
                "children": null,
                "value": {
                    "nodeSegments": segments,
                    "nodeSegmentSystemNames": [],
                    "nodeSegmentsMembers": [],
                    "nodeSegmentsMemberSystemNames": [],
                    "segmentLevel": 0
                }
            });
        });

        return rtnVal;
    };
    static GetFirstLevelMultiSegmentMembersNode = (segments, dimension, selections, iterator) => {
        let segmentAliases = [];
        let segmentSelections = [];
        for (let s = 0; s < segments.length; s++) {
            let currentSegment = segments[s];
            segmentAliases.push(currentSegment.alias);

            // If this is not the last segment selection node, three values need to be left blank
            if (s === (segments.length - 1)) {
                segmentSelections.push({
                    "segmentAlias": currentSegment.alias,
                    "segmentSystemName": currentSegment.systemName,
                    "dimensionAlias": "",
                    "dimensionSystemName": "",
                    "valueAlias": "All",
                    "valueSystemName": "",
                    "caption": "All Members",
                    "filter": null,
                    "isSelected": true,
                    "isMissing": false
                });
            } else {
                segmentSelections.push({
                    "segmentAlias": currentSegment.alias,
                    "segmentSystemName": currentSegment.systemName,
                    "dimensionAlias": "",
                    "dimensionSystemName": "",
                    "valueAlias": null,
                    "valueSystemName": null,
                    "caption": "",
                    "filter": null,
                    "isSelected": true,
                    "isMissing": false
                });
            }
        }

        let rtnVal = {
            "id": iterator,
            "name": `${segmentAliases.join(' ')} Segment Members`,
            "isExpanded": false,
            "isChecked": MembersTreeViewNodeHelper.IsThisMultiSegmentPartOfTheSelections(selections, segmentSelections),
            "isExpandable": false,
            "isCheckable": true,
            "lastChanged": null,
            "children": [],
            "value": {
                "segmentSelections": segmentSelections,
                "segmentCombination": segmentAliases.join('|'),
                "dimensionAlias": dimension.alias,
                "dimensionSystemName": dimension.systemName,
                "valueAlias": "All",
                "valueSystemName": "",
                "caption": `${segmentAliases.join(' ')} Segment Members`,
                "member": false,
                "segment": false,
                "multiSegment": true,
                "segmentNames": false,
                "segmentMembers": false
            }
        };

        return rtnVal;
    };
    static GetFirstLevelMultiSegmentRollupNode = (segments, dimension, selections, iterator) => {
        let segmentAliases = [];
        let segmentSelections = [];
        for (let s = 0; s < segments.length; s++) {
            let currentSegment = segments[s];
            segmentAliases.push(currentSegment.alias);

            // If this is not the last segment selection node, three values need to be left blank
            if (s === (segments.length - 1)) {
                segmentSelections.push({
                    "segmentAlias": currentSegment.alias,
                    "segmentSystemName": currentSegment.systemName,
                    "dimensionAlias": dimension.alias,
                    "dimensionSystemName": dimension.systemName,
                    "valueAlias": null,
                    "valueSystemName": null,
                    "caption": "Rollup",
                    "filter": null,
                    "isSelected": true,
                    "isMissing": false
                });
            } else {
                segmentSelections.push({
                    "segmentAlias": currentSegment.alias,
                    "segmentSystemName": currentSegment.systemName,
                    "dimensionAlias": dimension.alias,
                    "dimensionSystemName": dimension.systemName,
                    "valueAlias": null,
                    "valueSystemName": null,
                    "caption": "",
                    "filter": null,
                    "isSelected": true,
                    "isMissing": false
                });
            }
        }

        let rtnVal = {
            "id": iterator,
            "name": `${segmentAliases.join(' ')} Segment Rollup`,
            "isExpanded": false,
            "isChecked": MembersTreeViewNodeHelper.IsThisMultiSegmentPartOfTheSelections(selections, segmentSelections),
            "isExpandable": false,
            "isCheckable": true,
            "lastChanged": null,
            "children": [],
            "value": {
                "segmentSelections": segmentSelections,
                "segmentCombination": segmentAliases.join('|'),
                "dimensionAlias": dimension.alias,
                "dimensionSystemName": dimension.systemName,
                "valueAlias": null,
                "valueSystemName": null,
                "caption": `${segmentAliases.join(' ')} Segment Rollup`,
                "member": false,
                "segment": false,
                "multiSegment": true,
                "segmentNames": false,
                "segmentMembers": false
            }
        };
        
        return rtnVal;
    };
    static GetMultiSegmentMembersNode = (dimension, node, member, currentSegment, selections, iterator) => {
        let nodeSegments = node["value"]["nodeSegments"];
        let nodeSegmentSystemNames = node["value"]["nodeSegmentSystemNames"];
        let nodeSegmentsMembers = node["value"]["nodeSegmentsMembers"];
        let nodeSegmentsMemberSystemNames = node["value"]["nodeSegmentsMemberSystemNames"];
        let segmentSelections = [];
        let caption = "";

        // Add Previous Members
        for (let i = 0; i < nodeSegmentsMembers.length; i++) {
            segmentSelections.push({
                "segmentAlias": nodeSegments[i],
                "segmentSystemName": nodeSegmentSystemNames[i],
                "dimensionAlias": "",
                "dimensionSystemName": "",
                "valueAlias": nodeSegmentsMembers[i],
                "valueSystemName": nodeSegmentsMemberSystemNames[i],
                "caption": "",
                "filter": null,
                "isSelected": true,
                "isMissing": false
            });
            caption += `${nodeSegments[i]} ${nodeSegmentsMembers[i]} `;
        }

        // Add Current Member Data
        segmentSelections.push({
            "segmentAlias": node["value"]["valueAlias"],
            "segmentSystemName": node["value"]["valueSystemName"],
            "dimensionAlias": "",
            "dimensionSystemName": "",
            "valueAlias": member["alias"],
            "valueSystemName": member["systemName"],
            "caption": "",
            "filter": null,
            "isSelected": true,
            "isMissing": false
        });
        caption += `${node["value"]["valueAlias"]} ${member["alias"]}`;

        // Add Current Segment
        segmentSelections.push({
            "segmentAlias": currentSegment["alias"],
            "segmentSystemName": currentSegment["systemName"],
            "dimensionAlias": "",
            "dimensionSystemName": "",
            "valueAlias": "All",
            "valueSystemName": "",
            "caption": "All Members",
            "filter": null,
            "isSelected": true,
            "isMissing": false
        });
        caption += ` ${currentSegment["alias"]} Segment Members`;

        // New Node
        let rtnVal = {
            "id": iterator,
            "name": caption,
            "isExpanded": false,
            "isChecked": MembersTreeViewNodeHelper.IsThisMultiSegmentPartOfTheSelections(selections, segmentSelections),
            "isExpandable": false,
            "isCheckable": true,
            "lastChanged": null,
            "children": [],
            "value": {
                "segmentSelections": segmentSelections,
                "segmentCombination": nodeSegments.join('|'),
                "dimensionAlias": dimension.alias,
                "dimensionSystemName": dimension.systemName,
                "valueAlias": null,
                "valueSystemName": null,
                "caption": caption,
                "member": false,
                "segment": false,
                "multiSegment": true,
                "segmentNames": false,
                "segmentMembers": false
            }
        };

        return rtnVal;
    };
    static GetMultiSegmentRollupNode = (dimension, node, member, currentSegment, selections, iterator) => {
        let nodeSegments = node["value"]["nodeSegments"];
        let nodeSegmentSystemNames = node["value"]["nodeSegmentSystemNames"];
        let nodeSegmentsMembers = node["value"]["nodeSegmentsMembers"];
        let nodeSegmentsMemberSystemNames = node["value"]["nodeSegmentsMemberSystemNames"];
        let segmentSelections = [];
        let caption = "";

        // Add Previous Members
        for (let i = 0; i < nodeSegmentsMembers.length; i++) {
            segmentSelections.push({
                "segmentAlias": nodeSegments[i],
                "segmentSystemName": nodeSegmentSystemNames[i],
                "dimensionAlias": "",
                "dimensionSystemName": "",
                "valueAlias": nodeSegmentsMembers[i],
                "valueSystemName": nodeSegmentsMemberSystemNames[i],
                "caption": "",
                "filter": null,
                "isSelected": true,
                "isMissing": false
            });
            caption += `${nodeSegments[i]} ${nodeSegmentsMembers[i]} `;
        }

        // Add Current Member Data
        segmentSelections.push({
            "segmentAlias": node["value"]["valueAlias"],
            "segmentSystemName": node["value"]["valueSystemName"],
            "dimensionAlias": "",
            "dimensionSystemName": "",
            "valueAlias": member["alias"],
            "valueSystemName": member["systemName"],
            "caption": "",
            "filter": null,
            "isSelected": true,
            "isMissing": false
        });
        caption += `${node["value"]["valueAlias"]} ${member["alias"]}`;

        // Add Current Segment
        segmentSelections.push({
            "segmentAlias": currentSegment["alias"],
            "segmentSystemName": currentSegment["systemName"],
            "dimensionAlias": "",
            "dimensionSystemName": "",
            "valueAlias": null,
            "valueSystemName": null,
            "caption": "Rollup",
            "filter": null,
            "isSelected": true,
            "isMissing": false
        });
        caption += ` ${currentSegment["alias"]} Segment Rollup`;

        // New Node
        let rtnVal = {
            "id": iterator,
            "name": caption,
            "isExpanded": false,
            "isChecked": MembersTreeViewNodeHelper.IsThisMultiSegmentPartOfTheSelections(selections, segmentSelections),
            "isExpandable": false,
            "isCheckable": true,
            "lastChanged": null,
            "children": [],
            "value": {
                "segmentSelections": segmentSelections,
                "segmentCombination": nodeSegments.join('|'),
                "dimensionAlias": dimension.alias,
                "dimensionSystemName": dimension.systemName,
                "valueAlias": null,
                "valueSystemName": null,
                "caption": caption,
                "member": false,
                "segment": false,
                "multiSegment": true,
                "segmentNames": false,
                "segmentMembers": false
            }
        };

        return rtnVal;
    };
    static GetMultiSegmentRollupNodeLastSegment = (dimension, node, member, selections, iterator) => {
        let nodeSegments = node["value"]["nodeSegments"];
        let nodeSegmentSystemNames = node["value"]["nodeSegmentSystemNames"];
        let nodeSegmentsMembers = node["value"]["nodeSegmentsMembers"];
        let nodeSegmentsMemberSystemNames = node["value"]["nodeSegmentsMemberSystemNames"];
        let segmentSelections = [];
        let caption = "";

        // Add Previous Members
        for (let i = 0; i < nodeSegmentsMembers.length; i++) {
            segmentSelections.push({
                "segmentAlias": nodeSegments[i],
                "segmentSystemName": nodeSegmentSystemNames[i],
                "dimensionAlias": "",
                "dimensionSystemName": "",
                "valueAlias": nodeSegmentsMembers[i],
                "valueSystemName": nodeSegmentsMemberSystemNames[i],
                "caption": "",
                "filter": null,
                "isSelected": true,
                "isMissing": false
            });
            caption += `${nodeSegments[i]} ${nodeSegmentsMembers[i]} `;
        }

        // Add Current Member Data
        segmentSelections.push({
            "segmentAlias": node["value"]["valueAlias"],
            "segmentSystemName": node["value"]["valueSystemName"],
            "dimensionAlias": "",
            "dimensionSystemName": "",
            "valueAlias": member["alias"],
            "valueSystemName": member["systemName"],
            "caption": "Rollup",
            "filter": null,
            "isSelected": true,
            "isMissing": false
        });
        caption += `${node["value"]["valueAlias"]} ${member["alias"]} Segment Rollup`;

        // New Node
        let rtnVal = {
            "id": iterator,
            "name": caption,
            "isExpanded": false,
            "isChecked": MembersTreeViewNodeHelper.IsThisMultiSegmentPartOfTheSelections(selections, segmentSelections),
            "isExpandable": false,
            "isCheckable": true,
            "lastChanged": null,
            "children": [],
            "value": {
                "segmentSelections": segmentSelections,
                "segmentCombination": nodeSegments.join('|'),
                "dimensionAlias": dimension.alias,
                "dimensionSystemName": dimension.systemName,
                "valueAlias": null,
                "valueSystemName": null,
                "caption": caption,
                "member": false,
                "segment": false,
                "multiSegment": true,
                "segmentNames": false,
                "segmentMembers": false
            }
        };

        return rtnVal;
    };
    static GetMultiSegmentMembersNodeLastSegment = (dimension, node, member, currentSegment, selections, iterator) => {
        let nodeSegments = node["value"]["nodeSegments"];
        let nodeSegmentSystemNames = node["value"]["nodeSegmentSystemNames"];
        let nodeSegmentsMembers = node["value"]["nodeSegmentsMembers"];
        let nodeSegmentsMemberSystemNames = node["value"]["nodeSegmentsMemberSystemNames"];
        let segmentSelections = [];
        let caption = "";

        // Add Previous Members
        for (let i = 0; i < nodeSegmentsMembers.length; i++) {
            segmentSelections.push({
                "segmentAlias": nodeSegments[i],
                "segmentSystemName": nodeSegmentSystemNames[i],
                "dimensionAlias": "",
                "dimensionSystemName": "",
                "valueAlias": nodeSegmentsMembers[i],
                "valueSystemName": nodeSegmentsMemberSystemNames[i],
                "caption": "",
                "filter": null,
                "isSelected": true,
                "isMissing": false
            });
            caption += `${nodeSegments[i]} ${nodeSegmentsMembers[i]} `;
        }

        // Add Current Member Data
        segmentSelections.push({
            "segmentAlias": node["value"]["valueAlias"],
            "segmentSystemName": node["value"]["valueSystemName"],
            "dimensionAlias": "",
            "dimensionSystemName": "",
            "valueAlias": member["alias"],
            "valueSystemName": member["systemName"],
            "caption": "All Members",
            "filter": null,
            "isSelected": true,
            "isMissing": false
        });
        caption += `${node["value"]["valueAlias"]} ${member["alias"]} Segment Members`;

        // New Node
        let rtnVal = {
            "id": iterator,
            "name": caption,
            "isExpanded": false,
            "isChecked": MembersTreeViewNodeHelper.IsThisMultiSegmentPartOfTheSelections(selections, segmentSelections),
            "isExpandable": false,
            "isCheckable": true,
            "lastChanged": null,
            "children": [],
            "value": {
                "segmentSelections": segmentSelections,
                "segmentCombination": nodeSegments.join('|'),
                "dimensionAlias": dimension.alias,
                "dimensionSystemName": dimension.systemName,
                "valueAlias": null,
                "valueSystemName": null,
                "caption": caption,
                "member": false,
                "segment": false,
                "multiSegment": true,
                "segmentNames": false,
                "segmentMembers": false
            }
        };

        return rtnVal;
    };
    static GetAllQuickPicksSelections = (selections, quickPicksTag, dataSource) => {
        let rtnVal = [];

        if (quickPicksTag.dataSourceWitMostMembers && quickPicksTag.dataSourceSelections[dataSource] && selections.length > 0) {
            let totalPossibleQuickPicks = quickPicksTag.dataSourceSelections[dataSource].length;
            let firstSelection = selections[0];

            for (let x = 0; x < totalPossibleQuickPicks; x++) {
                let name = `${firstSelection.dimensionAlias}  (QuickPicks)`;
                let selectionObjectName = dataSource;

                let regexCompTest = new RegExp(' - Comp[1-9]+');
                let regexCompTest2 = new RegExp(' - Comp');
                let testStr = quickPicksTag.dataSourceSelections[dataSource][x]["selectionName"];
                let isComp = false;
                if (regexCompTest.test(testStr)) {
                    isComp = true;
                    let matchingPart = testStr.match(regexCompTest)[0];
                    name = `${firstSelection.dimensionAlias}${matchingPart} (QuickPicks)`;
                    selectionObjectName = `${dataSource}${matchingPart}`;
                } else if (regexCompTest2.test(testStr)) {
                    isComp = true;
                    let matchingPart = testStr.match(regexCompTest2)[0];
                    name = `${firstSelection.dimensionAlias}${matchingPart} (QuickPicks)`;
                    selectionObjectName = `${dataSource}${matchingPart}`;
                } else {
                    isComp = false;
                    name = `${firstSelection.dimensionAlias} (QuickPicks)`;
                    selectionObjectName = dataSource;
                }

                let isChecked = false;

                if (quickPicksTag["dataConnectionName"] === "PowerBI") {
                    let lookup = undefined;

                    if (isComp) {
                        lookup = selections.find(s => s.selectionObjectName.indexOf(`$${selectionObjectName}`) > -1);
                    } else {
                        lookup = selections.find(s => s.selectionObjectName.indexOf(`$${selectionObjectName}.`) > -1);
                    }

                    isChecked = lookup !== undefined;
                    if (lookup !== undefined) {
                        selectionObjectName = lookup["selectionObjectName"];
                    } else {
                        isChecked = false;
                        let selectionNameLookup = quickPicksTag["dataSourceSelections"]["DATA"].find(s => s.selectionName === selectionObjectName);
                        if (selectionNameLookup !== undefined) {
                            selectionObjectName = `$${selectionNameLookup.selectionName}.${selectionNameLookup.selectionValue}`
                        }
                    }
                } else {
                    isChecked = selections.find(s => s.selectionObjectName === selectionObjectName) !== undefined;
                }

                rtnVal.push({
                    "id": `qp-${firstSelection.dimensionAlias}-${x}`,
                    "name": name,
                    "isExpanded": false,
                    "isChecked": isChecked,
                    "isExpandable": false,
                    "isCheckable": true,
                    "lastChanged": null,
                    "children": null,
                    "value": {
                        "caption": name,
                        "selectionObjectName": selectionObjectName,
                        "dimensionAlias": firstSelection.dimensionAlias,
                        "dimensionSystemName": firstSelection.dimensionSystemName,
                        "valueAlias": firstSelection.valueAlias,
                        "valueSystemName": firstSelection.valueSystemName,
                        "member": false,
                        "segment": false,
                        "multiSegment": false,
                        "segmentNames": false,
                        "segmentMembers": false
                    }
                })
            }
        }

        return rtnVal;
    };
    static GetAllGlobalsSelections = (selections, globals, dataSource, dimensionAlias) => {
        let rtnVal = []

        for (let globalsIndex = 0; globalsIndex < globals.length; globalsIndex++) {
            let currentGlobal = globals[globalsIndex]
            let parameters = currentGlobal["parameters"]
            for (let parameterIndex = 0; parameterIndex < parameters.length; parameterIndex++) {
                let currentGlobalParameter = parameters[parameterIndex]
                if (currentGlobalParameter["dimensionAlias"] === dimensionAlias) {
                    // Check if this is already selected
                    let isChecked = false
                    for (let selectionIndex = 0; selectionIndex < selections.length; selectionIndex++) {
                        let currentSelection = selections[selectionIndex]
                        if (!isChecked && currentSelection["globalSet"]) {
                            isChecked = (currentGlobal["setName"] === currentSelection["globalSet"]) && (currentGlobalParameter["parameterName"] === currentSelection["globalParameter"])
                        }
                    }

                    rtnVal.push({
                        "id": `gs-${currentGlobal["setName"]}.${currentGlobalParameter["parameterName"]}-${parameterIndex}`,
                        "name": `${currentGlobal["setName"]}.${currentGlobalParameter["parameterName"]}  (Global)`,
                        "isExpanded": false,
                        "isChecked": isChecked,
                        "isExpandable": false,
                        "isCheckable": true,
                        "lastChanged": null,
                        "children": null,
                        "value": {
                            "caption": `${currentGlobal["setName"]}.${currentGlobalParameter["parameterName"]}  (Global)`,
                            "dimensionAlias": dimensionAlias,
                            "dimensionSystemName": `[${currentGlobal["setName"]}_${dimensionAlias}].[${currentGlobal["setName"]}_${dimensionAlias}]`,
                            "filter": null,
                            "globalParameter": currentGlobalParameter["parameterName"],
                            "globalSet": currentGlobal["setName"],
                            "isMissing": false,
                            "isSelected": isChecked,
                            "valueAlias": null,
                            "valueSystemName": null
                        }
                    });
                }
            }
        }

        return rtnVal
    };

    // Check if part of selections
    static IsThisMemberDimensionPartOfTheSelections = (selected, member) => {
        let rtnVal = false;

        selected.forEach(s => {
            if (s["valueSystemName"] === member["systemName"] && s["isSelected"] === true) {
                rtnVal = true;
            }
        });

        return rtnVal;
    }
    static IsThisSegmentMemberNodePartOfTheSelections = (selected, segment) => {
        let rtnVal = false;

        selected.forEach(s => {
            if (s["isSelected"] === true &&
                s["segmentSystemName"] !== undefined &&
                s["segmentSystemName"] === segment["systemName"] &&
                s["valueAlias"] === "All" &&
                s["valueSystemName"] === "") {
                rtnVal = true;
            }
        });

        return rtnVal;
    }
    static IsThisSegmentRollupNodePartOfTheSelections = (selected, segment) => {
        let rtnVal = false;

        selected.forEach(s => {
            if (s["isSelected"] === true &&
                s["segmentSystemName"] !== undefined &&
                s["segmentSystemName"] === segment["systemName"] &&
                s["valueAlias"] === null &&
                s["valueSystemName"] === null) {
                rtnVal = true;
            }
        });

        return rtnVal;
    }
    static IsThisMemberSegmentDimensionPartOfTheSelections = (selected, member, segment) => {
        let rtnVal = false;

        selected.forEach(s => {
            if (s["parentName"] !== undefined && s["isSelected"] === true) {
                if (s["parentName"] === `[${segment["alias"]}] == [${member["alias"]}]` && s["valueSystemName"] === segment["systemName"]) {
                    rtnVal = true;
                }
            }
        });

        return rtnVal;
    }
    static IsThisRollupSegmentDimensionPartOfTheSelections = (selected, member, segment) => {
        let rtnVal = false;

        selected.forEach(s => {
            if (s["valueSystemName"] !== undefined && s["segmentSystemName"] !== undefined && s["isSelected"] === true) {
                if (s["segmentSystemName"] === segment["systemName"] && s["valueSystemName"] === member["systemName"]) {
                    rtnVal = true;
                }
            }
        });

        return rtnVal;
    }
    static IsThisMultiSegmentPartOfTheSelections = (selected, builtSegmentSelections) => {
        let rtnVal = false;

        // Go through the selections first, get each node and determine if we have a match that way
        selected.forEach(selection => {
            if (selection["segmentSelections"] !== undefined && selection["segmentSelections"] !== null && selection["isSelected"] === true) {
                let match = true;
                let segmentSelections = selection["segmentSelections"];

                // Go through the selected segment selections and compare the values to what was passed
                segmentSelections.forEach(segmentSelection => {
                    let lookup = builtSegmentSelections.find(x =>
                        segmentSelection["segmentAlias"] === x["segmentAlias"] &&
                        segmentSelection["segmentSystemName"] === x["segmentSystemName"] &&
                        segmentSelection["valueAlias"] === x["valueAlias"] &&
                        segmentSelection["valueSystemName"] === x["valueSystemName"] &&
                        segmentSelection["caption"] === x["caption"]);

                    if (lookup === undefined) {
                        match = false;
                    }
                });

                if (match === true) {
                    rtnVal = true;
                }
            }
        });

        return rtnVal;
    };
}